export default {
  background: '#ffff',
};
